import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, roles }) => {
  // LocalStorage'dan authentication durumunu kontrol et
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userEmail = localStorage.getItem('userEmail');

  // Eğer kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!isAuthenticated || !userEmail) {
    return <Navigate to="/giris" replace />;
  }

  if (roles?.length) {
    try {
      const userRole = JSON.parse(localStorage.getItem('userData') || '{}')?.role || 'employee';

      if (!roles.includes(userRole)) {
        return <Navigate to="/anasayfa" replace />;
      }
    } catch (error) {
      return <Navigate to="/anasayfa" replace />;
    }
  }

  // Eğer kullanıcı giriş yapmışsa, korunan sayfayı göster
  return children;
};

export default ProtectedRoute;
